'use client';

import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';

import { Input } from '@/components/ui/input/input.component';

export interface ClientListFilterInputProps {
  'value': string;
  'onChange': (value: string) => void;
  'placeholder': string;
  'className'?: string;
  'aria-label'?: string;
}

export function ClientListFilterInput({
  value,
  onChange,
  placeholder,
  className,
  'aria-label': ariaLabel,
}: ClientListFilterInputProps) {
  return (
    <Input
      type="text"
      role="searchbox"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      startIcon={faMagnifyingGlass}
      className={className}
      aria-label={ariaLabel ?? placeholder}
      autoComplete="off"
    />
  );
}
